/* eslint-disable max-len */
import React from "react";
import "./Seperator.scss";

const Seperator = ({ ...props }) => <div className="seperator" {...props} />;
export default Seperator;
